import * as React from "react";
import Select from "@mui/material/Select";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DeleteIcon from "@material-ui/icons/Delete";
import { statusArray } from "components/helpers";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import {
  Controller,
  useFormContext,
  useFieldArray,
  useWatch,
} from "react-hook-form";
import "./styles.css";
import htmlText from "../htmlText";

export default function UserDetails() {
  const [expanded, setExpanded] = React.useState(0);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const {
    control,
    formState: { errors },
    trigger,
    getValues,
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "user",
  });
  const watchedValue = useWatch("user");
  const { provider } = getValues();

  const userFields = watchedValue?.user.length ? watchedValue?.user : fields;

  return (
    <>
      {userFields.map((item, index) => (
        <Accordion
          expanded={expanded === index}
          onChange={handleChange(index)}
          key={index}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography>User #{index + 1}</Typography>
              {index >= 1 && <DeleteIcon onClick={() => remove(index)} />}
            </div>
          </AccordionSummary>
          <AccordionDetails style={{ display: "block" }}>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Provider List</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`user.${index}.access_type`}
                  control={control}
                  rules={{
                    required: htmlText.thisFieldIsRequired,
                  }}
                  render={({ field }) => (
                    <>
                      <Select
                        variant="standard"
                        native
                        style={{ width: "100%" }}
                        {...field}
                      >
                        <option value=""></option>
                        {["Provider", "Non Provider"].map((s) => (
                          <option key={s} value={s}>
                            {s}
                          </option>
                        ))}
                      </Select>
                    </>
                  )}
                />
              </Grid>
            </Grid>
            {item?.access_type === "Provider" && (
              <Grid container style={{ marginTop: 10 }}>
                <Grid item xs={6}>
                  <p>Select Provider</p>
                </Grid>
                <Grid item xs={6}>
                  <Controller
                    name={`user.${index}.selectedProvider`}
                    control={control}
                    defaultValue={item.selectedProvider}
                    render={({ field }) => (
                      <>
                        <Select
                          variant="standard"
                          native
                          style={{ width: "100%" }}
                          {...field}
                        >
                          <option value=""></option>
                          {provider.map((s, i) => (
                            <option key={i} value={i}>
                              {s.first_name} {s.last_name}
                            </option>
                          ))}
                        </Select>
                      </>
                    )}
                  />
                </Grid>
              </Grid>
            )}
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>User Name</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`user[${index}].user_name`}
                  control={control}
                  defaultValue={item.user_name}
                  render={({ field }) => (
                    <>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.user &&
                          Boolean(errors?.user[index]?.user_name)
                        }
                        onBlur={() => trigger(`user[${index}].user_name`)}
                      />
                      {errors?.user &&
                        errors?.user[index]?.user_name?.message && (
                          <FormHelperText
                            error={
                              errors?.user &&
                              Boolean(errors?.user[index]?.user_name)
                            }
                          >
                            {errors?.user[index]?.user_name?.message}
                          </FormHelperText>
                        )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>User Email</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`user[${index}].user_id`}
                  defaultValue={item.user_id}
                  control={control}
                  rules={{
                    required: htmlText.thisFieldIsRequired,
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Invalid email address",
                    },
                  }}
                  render={({ field }) => (
                    <>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.user && Boolean(errors?.user[index]?.user_id)
                        }
                        onBlur={() => trigger(`user[${index}].user_id`)}
                      />
                      {errors?.user &&
                        errors?.user[index]?.user_id?.message && (
                          <FormHelperText
                            error={
                              errors?.user &&
                              Boolean(errors?.user[index]?.user_id)
                            }
                          >
                            {errors?.user[index]?.user_id?.message}
                          </FormHelperText>
                        )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Title</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`user[${index}].title`}
                  defaultValue={item.title}
                  control={control}
                  render={({ field }) => (
                    <>
                      <TextField
                        required
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.user && Boolean(errors?.user[index]?.title)
                        }
                        onBlur={() => trigger(`user[${index}].title`)}
                      />
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>First Name</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`user[${index}].first_name`}
                  control={control}
                  key={
                    item?.selectedProvider
                      ? provider[Number(item?.selectedProvider)].first_name
                      : item.first_name
                  }
                  defaultValue={
                    item?.selectedProvider
                      ? provider[Number(item?.selectedProvider)].first_name
                      : item.first_name
                  }
                  render={({ field }) => (
                    <>
                      <TextField
                        required
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.user &&
                          Boolean(errors?.user[index]?.first_name)
                        }
                        onBlur={() => trigger(`user[${index}].first_name`)}
                      />
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Last Name</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`user[${index}].last_name`}
                  control={control}
                  key={
                    item?.selectedProvider
                      ? provider[Number(item?.selectedProvider)].last_name
                      : item.last_name
                  }
                  defaultValue={
                    item?.selectedProvider
                      ? provider[Number(item?.selectedProvider)].last_name
                      : item.last_name
                  }
                  render={({ field }) => (
                    <>
                      <TextField
                        required
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.user &&
                          Boolean(errors?.user[index]?.last_name)
                        }
                        onBlur={() => trigger(`user[${index}].last_name`)}
                      />
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Full Name</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`user[${index}].full_name`}
                  defaultValue={item.full_name}
                  control={control}
                  render={({ field }) => (
                    <>
                      <TextField
                        required
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.user &&
                          Boolean(errors?.user[index]?.full_name)
                        }
                        onBlur={() => trigger(`user[${index}].full_name`)}
                      />
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Phone No</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`user[${index}].phone`}
                  control={control}
                  key={
                    item?.selectedProvider
                      ? provider[Number(item?.selectedProvider)].phone
                      : item.phone
                  }
                  defaultValue={
                    item?.selectedProvider
                      ? provider[Number(item?.selectedProvider)].phone
                      : item.phone
                  }
                  rules={{
                    required: htmlText.thisFieldIsRequired,
                    pattern: {
                      value: /^(\+\d{1,3}[- ]?)?\d{10}$/,
                      message: "Invalid contact number",
                    },
                  }}
                  render={({ field }) => (
                    <>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.user && Boolean(errors?.user[index]?.phone)
                        }
                        onBlur={() => trigger(`user[${index}].phone`)}
                      />
                      {errors?.user && errors?.user[index]?.phone?.message && (
                        <FormHelperText
                          error={
                            errors?.user && Boolean(errors?.user[index]?.phone)
                          }
                        >
                          {errors?.user[index]?.phone?.message}
                        </FormHelperText>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>NPI</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`user.${index}.npi`}
                  control={control}
                  key={
                    item?.selectedProvider
                      ? provider[Number(item?.selectedProvider)].npi
                      : item.npi
                  }
                  defaultValue={
                    item?.selectedProvider
                      ? provider[Number(item?.selectedProvider)].npi
                      : item.npi
                  }
                  render={({ field }) => (
                    <>
                      <TextField
                        fullWidth
                        size="small"
                        rules={{
                          required: false,
                          pattern: {
                            value: /^\d{10}$/,
                            message: "NPI should be 10 digits",
                          },
                        }}
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.user && Boolean(errors?.user[index]?.npi)
                        }
                        onBlur={() => trigger("practice.npi")}
                      />
                      {errors?.user && errors?.user[index]?.npi?.message && (
                        <FormHelperText
                          error={
                            errors?.user && Boolean(errors?.user[index]?.npi)
                          }
                        >
                          {errors?.user[index]?.npi_primary?.message}
                        </FormHelperText>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>User Role</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`user.${index}.user_role`}
                  defaultValue={item.user_role}
                  control={control}
                  rules={{ required: htmlText.thisFieldIsRequired }}
                  render={({ field }) => (
                    <>
                      <Select
                        variant="standard"
                        native
                        style={{ width: "100%" }}
                        {...field}
                      >
                        <option value=""></option>
                        {["Admin", "Provider"].map((s) => (
                          <option key={s} value={s}>
                            {s}
                          </option>
                        ))}
                      </Select>
                      {errors?.user &&
                        errors?.user[index]?.user_role?.message && (
                          <FormHelperText
                            error={
                              errors?.user &&
                              Boolean(errors?.user[index]?.user_role)
                            }
                          >
                            {errors?.user[index]?.user_role?.message}
                          </FormHelperText>
                        )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Status</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`user.${index}.status`}
                  defaultValue={item.status}
                  control={control}
                  render={({ field }) => (
                    <>
                      <Select
                        variant="standard"
                        native
                        style={{ width: "100%" }}
                        {...field}
                      >
                        <option value=""></option>
                        {statusArray.map((s) => (
                          <option key={s} value={s}>
                            {s}
                          </option>
                        ))}
                      </Select>
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 10 }}>
              <Grid item xs={6}>
                <p>Password</p>
              </Grid>
              <Grid item xs={6}>
                <Controller
                  name={`user[${index}].password`}
                  defaultValue={item.password}
                  control={control}
                  rules={{
                    required: htmlText.thisFieldIsRequired,
                    pattern: {
                      value:
                        /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/,
                      message: `Your password needs to be:\n Include both lower and uppercase character\nInclude atleast 1 number or symbol\n atleast 8 character long.`,
                    },
                  }}
                  render={({ field }) => (
                    <>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{ marginBottom: 0 }}
                        {...field}
                        error={
                          errors?.user && Boolean(errors?.user[index]?.password)
                        }
                        onBlur={() => trigger(`user[${index}].password`)}
                      />
                      {errors?.user &&
                        errors?.user[index]?.password?.message && (
                          <FormHelperText
                            error={
                              errors?.user &&
                              Boolean(errors?.user[index]?.password)
                            }
                          >
                            {errors?.user[index]?.password?.message}
                          </FormHelperText>
                        )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      ))}
      <div className="udm-btn-cont">
        <button
          className="udm-save"
          type="button"
          onClick={() => {
            append({
              user_name: "",
              user_role: "",
              user_id: "",
              status: "",
              full_name: "",
              first_name: "",
              last_name: "",
              title: "",
              npi: "",
              password: "",
              phone: "",
            });
          }}
        >
          + Add New
        </button>
      </div>
    </>
  );
}
